export enum FormTab {
	BASIC_INFORMATION = 'Basic Information',
}
